export default "__VITE_ASSET__Cjj0ZrCb__"